// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__YHsgZ","column":"style_column__2cX6C"};